const vatTypes = [
    {
        name: "VAT_FIRST",
        value: 1
    },
    {
        name: "VAT_SECOND",
        value: 2
    },
    {
        name: "EXEMPT",
        value: 3
    }
];

export default vatTypes;